module.exports = __webpack_public_path__ + "static/media/18ECA25.8c859fcf.jpg";